import "core-js/modules/es.array.reduce";

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author:
 *
 *Description:
*/
import Immutable from 'immutable';
import * as actions from './actions';
import CmsRecord from '../../records/CmsRecord';

var cmsReducer = function cmsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Immutable.Map();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions.CMS_REQUEST_START:
      return state.merge(action.ids.reduce(function (collection, id, i) {
        var $id = state.keySeq().toArray()[i];
        var $component = state.get($id);
        collection[id] = $component ? $component.merge({
          id: id,
          isFetching: true
        }) : CmsRecord({
          id: id,
          isFetching: true
        });
        return collection;
      }, {}));

    case actions.CMS_SET_DATA:
      {
        return state.merge(action.ids.reduce(function (collection, id, i) {
          var $component = state.get(id);
          var $id = action.data.keySeq().toArray()[i];
          var $data = action.data.getIn([$id, 'data']);

          if ($component) {
            collection[id] = $component.merge({
              data: $data
            });
          }

          return collection;
        }, {}));
      }

    case actions.CMS_REQUEST_END:
      return state.merge(action.ids.reduce(function (collection, id) {
        var $component = state.get(id);

        if ($component) {
          collection[id] = $component.merge({
            id: id,
            isFetching: false
          });
        }

        return collection;
      }, {}));

    default:
      return state;
  }
};

export default cmsReducer;